'use client';

import { useIdPath } from '@/contexts/IdPathProvider';
import { useEffect } from 'react';

export default function GoogleAnalytics() {
    const { projectValue, isLoading } = useIdPath();

    useEffect(() => {
        // Chỉ chạy khi đã load xong và có id_google_analytics
        if (isLoading || !projectValue?.id_google_analytics) {
            return;
        }

        const googleAnalyticsId = projectValue.id_google_analytics as string;

        // Validate GA format strictly (e.g., G-XXXXXXXXXX or UA-XXXXX-Y)
        if (!/^[a-zA-Z0-9-_]+$/.test(googleAnalyticsId)) {
            console.warn('[GoogleAnalytics] Invalid Google Analytics ID format');
            return;
        }

        // Kiểm tra xem script đã được load chưa
        const existingScript = document.querySelector(`script[src*="${googleAnalyticsId}"]`);
        if (existingScript) {
            return;
        }

        // Tạo và thêm script gtag.js
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${googleAnalyticsId}`;
        document.head.appendChild(script);

        // Tạo và thêm script cấu hình
        const configScript = document.createElement('script');
        configScript.innerHTML = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${googleAnalyticsId}');
        `;
        document.head.appendChild(configScript);

        // Cleanup function
        return () => {
            // Không xóa script vì có thể cần thiết cho tracking
        };
    }, [projectValue, isLoading]);

    return null; // Component này không render gì
}